import IconPlaceholder from 'assets/icons/IconPlaceholder.svg'
import { nextImageLoaderProp } from 'common/utils/misc'
import Image from 'next/image'
import { FileUploadSelectParams } from 'primereact/fileupload'
import { FC, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Upload } from './Upload'

interface IUploadPhoto {
  file: File | string
  handleChange: (e: FileUploadSelectParams | null) => void
  name: string
  error?: string | boolean
}

export const UploadPhoto: FC<IUploadPhoto> = ({ file, name, handleChange, error }) => {
  //utils
  const cancelRef = useRef<any>(null)

  //effects
  useEffect(() => {
    if (typeof file === 'string') {
      cancelRef.current?.children[0].click()
    }
  }, [file])

  //handlers
  const handleRemove = (callback: any) => {
    handleChange(null)
    callback()
  }

  return (
    <div className="flex gap-3 align-items-center">
      {file ? (
        <StyledImage
          width={80}
          height={80}
          src={typeof file !== 'string' ? URL.createObjectURL(file) : file}
          alt="UserImg"
          loader={nextImageLoaderProp}
          style={{ objectFit: 'cover' }}
          unoptimized
        />
      ) : (
        <IconPlaceholder />
      )}
      <Upload
        cancelButtonRef={cancelRef}
        accept="image/*"
        name={name}
        handleRemove={handleRemove}
        handleSelect={handleChange}
        error={error}
      />
    </div>
  )
}

const StyledImage = styled(Image)`
  border-radius: 80px;
`
